export const DEVICE_BASE_PATH = '/device/';
export const JOB_BASE_PATH = '/job/';
